/**
 * Mapear aquí todas las expresiones regulares de la aplicación:
 */

export const onlyNumbers = '^[0-9]*$';

/**
 * @description el separador del decimal es el punto (.)
 */
export const decimalNumber = '^[0-9]*\\.?[0-9]*$';

/**
 * @description El string debe contener:
 *  - Mínimo uno de los siguientes caracteres: @ $ ! % * # ? & ^ _ - 
 *  - Números y Letras (Mayúsculas y Minúsculas)</li>
 *  - Mínimo 6 caracteres </li>
 */
export const securePassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{6,}$/


export const hasUpper = /[A-Z]/;

export const hasLower = /[a-z]/;

export const hasNumber = /\d/;

export const hasSpecial = /[@$!%*#?&^_-]/;

export const minLength = /.{8,}/;

export const hasSlug = /^[a-zA-Z0-9_]+$/;

export const hasMoney = /^\d+(\.\d{0,2})?$/;

/**
 * @description Email Minimalista
 */
export const emailRegEx = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/